export default "__VITE_ASSET__BAm1etMb__"